import { FgType } from '../types.js';

const NODE_TRS_PROPS = {
  translation: { prop: "translation", type: FgType.Vector3 },
  rotation: { prop: "rotation", type: FgType.Quaternion },
  scale: { prop: "scale", type: FgType.Vector3 }
};

export { NODE_TRS_PROPS };
//# sourceMappingURL=object-model-mapping.js.map
